import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * Working with value pairs.
 *
 * @module pair
 */

/**
 * @template L,R
 */
export var Pair =
/**
 * @param {L} left
 * @param {R} right
 */
function Pair(left, right) {
  _classCallCheck(this, Pair);

  this.left = left;
  this.right = right;
};
/**
 * @template L,R
 * @param {L} left
 * @param {R} right
 * @return {Pair<L,R>}
 */

export var create = function create(left, right) {
  return new Pair(left, right);
};
/**
 * @template L,R
 * @param {R} right
 * @param {L} left
 * @return {Pair<L,R>}
 */

export var createReversed = function createReversed(right, left) {
  return new Pair(left, right);
};
/**
 * @template L,R
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):any} f
 */

export var forEach = function forEach(arr, f) {
  return arr.forEach(function (p) {
    return f(p.left, p.right);
  });
};
/**
 * @template L,R,X
 * @param {Array<Pair<L,R>>} arr
 * @param {function(L, R):X} f
 * @return {Array<X>}
 */

export var map = function map(arr, f) {
  return arr.map(function (p) {
    return f(p.left, p.right);
  });
};